const { debounce } = window.BAO.Utils

class AccordionGroup extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (this.dataset.disableDesktop === 'true') this.toggleFocusEls()
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleTabTrigger = this.handleTabTrigger.bind(this)
    this.handleHover = this.handleHover.bind(this)

    if (this?.els?.trigger?.exists) {
      this.els.trigger.elements.forEach(triggerEl => {
        this.listeners.add(triggerEl, 'click', this.handleTrigger)
      })

      if (this.dataset.hover === 'true') {
        this.els.trigger.elements.forEach(triggerEl => {
          this.listeners.add(triggerEl, 'mouseover', this.handleHover)
        })
      }
    }

    if (this?.els?.tab?.exists) {
      this.els.tab.elements.forEach(tabEl => {
        this.listeners.add(tabEl, 'click', this.handleTabTrigger)
      })
    }

    if (this.dataset.disableDesktop === 'true') {
      this.onResize = this.onResize.bind(this)
      this.listeners.add(window, 'resize', debounce(this.onResize, 200))
    }
  }

  onResize () {
    this.toggleFocusEls()
  }

  toggleFocusEls () {
    this.els.trigger.elements.forEach(el => {
      if (window.BAO.MediaBreakpoints.isMd) {
        el.setAttribute('tabindex', '-1')
      } else {
        el.removeAttribute('tabindex')
      }
    })
  }

  handleTabTrigger (e) {
    const label = e.currentTarget.dataset.label

    const potentialTab = this.els.trigger.elements.find(
      element => element.dataset.label === label,
    )

    if (!potentialTab) return

    potentialTab.click()
  }

  handleHover (event) {
    const itemEl = event.target.closest(this.els?.item?.selector)
    if (!itemEl) return

    if (this.dataset.type === 'oneopen') {
      this.els?.item?.elements.forEach(tempEl => {
        if (tempEl !== itemEl) {
          tempEl.setAttribute('aria-expanded', 'false')
        }
      })
    }

    itemEl.setAttribute('aria-expanded', 'true')
  }

  handleTrigger (event) {
    const triggerEl = event.target.closest(this.els?.trigger?.selector)
    const itemEl = event.target.closest(this.els?.item?.selector)
    const contentEl = itemEl.querySelector(this.els?.content?.selector)

    if (this.dataset.type === 'oneopen') {
      this.els?.trigger?.elements.forEach(tempEl => {
        if (tempEl !== triggerEl) {
          tempEl.setAttribute('aria-expanded', 'false')
        }
      })

      this.els?.item?.elements.forEach(tempEl => {
        if (tempEl !== itemEl && tempEl.dataset.expandedDefault !== 'true') {
          tempEl.setAttribute('aria-expanded', 'false')
        }
      })

      this.els?.content?.elements.forEach(tempEl => {
        if (tempEl !== contentEl) {
          tempEl.setAttribute('aria-hidden', 'true')
        } else {
          tempEl.setAttribute('aria-hidden', 'false')
        }
      })

      if (this?.els?.tab?.exists) {
        const label = event.currentTarget.dataset.label

        this.els?.tab?.elements.forEach(tabEl => {
          if (tabEl.dataset.label !== label) {
            tabEl.setAttribute('aria-selected', 'false')
          }
        })
      }
    }

    const currentState = triggerEl.getAttribute('aria-expanded') === 'true'

    triggerEl.setAttribute('aria-expanded', !currentState)
    if (this.dataset.id === 'footer') {
      itemEl.setAttribute('data-expanded', !currentState)
    } else {
      itemEl.setAttribute('aria-expanded', !currentState)
    }

    if (this?.els?.tab?.exists) {
      const label = event.currentTarget.dataset.label

      this.els?.tab?.elements.forEach(tabEl => {
        if (tabEl.dataset.label === label) {
          tabEl.setAttribute('aria-selected', !currentState)
        }
      })
    }

    if (this.dataset.duplicate === 'true') {
      this.handleDuplicates(itemEl.dataset.index)
    }

    if (this.dataset.id === 'menu') {
      window.setTimeout(() => {
        itemEl.scrollIntoView({
          behavior: 'smooth',
          block: 'end',
          inline: 'nearest',
        })
      }, 500)
    }
  }

  handleDuplicates (itemElIndex) {
    const duplicateAccordionId = this.dataset.id

    document
      .querySelectorAll(`accordion-group[data-id="${duplicateAccordionId}"]`)
      .forEach(accordionGroup => {
        if (accordionGroup === this) return

        const duplicateItemEl = accordionGroup.querySelector(
          `[data-accordion-group-el="item"][data-index="${itemElIndex}"]`,
        )

        const duplicateTriggerEl = accordionGroup.querySelector(
          `[data-accordion-group-el="item"][data-index="${itemElIndex}"] [data-accordion-group-el="trigger"]`,
        )

        if (this.dataset.type === 'oneopen') {
          accordionGroup
            .querySelectorAll('[data-accordion-group-el="item"]')
            .forEach(tempEl => {
              if (tempEl !== duplicateItemEl) {
                tempEl.setAttribute('data-expanded', 'false')
              }
            })

          accordionGroup
            .querySelectorAll('[data-accordion-group-el="trigger"]')
            .forEach(tempEl => {
              if (tempEl !== duplicateTriggerEl) {
                tempEl.setAttribute('aria-expanded', 'false')
              }
            })
        }

        const duplicateCurrentState =
          duplicateItemEl.getAttribute('data-expanded') === 'true'
        duplicateItemEl.setAttribute('data-expanded', !duplicateCurrentState)

        const duplicateCurrentStateTrigger =
          duplicateTriggerEl.getAttribute('aria-expanded') === 'true'
        duplicateTriggerEl.setAttribute(
          'aria-expanded',
          !duplicateCurrentStateTrigger,
        )
      })
  }
}

if (!customElements.get('accordion-group')) {
  customElements.define('accordion-group', AccordionGroup)
}
